import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {NationalOrganizationReport} from 'src/app/shared/Models/NationalOrganizationReport'
import {CampaignsService} from 'src/app/shared/API-Service/services/campaigns.service'
@Component({
  selector: 'app-national-organization-report',
  templateUrl: './national-organization-report.component.html',
  styleUrls: ['./national-organization-report.component.css']
})
export class NationalOrganizationReportComponent  {
  ReportsInfo = new NationalOrganizationReport()
  ReceiptBooks: any;
  ReceiptStatus: any;
  currentUser: any;
  Campaigns: any;
  constructor(private router: Router,private CampaignsService:CampaignsService) {
  
  }

  ngOnInit(): void {
    this.GetCampaigns();
  }
  GetCampaigns(){
    this.CampaignsService.GetCampaign().subscribe(res=>{
      this.Campaigns=res.data
    })
  }
  SelectCampaign(event){
    this.ReportsInfo.campaignId = parseInt(event) 
    this.ReportsInfo.campaignTitle = this.Campaigns.find(x => x.id == event).title
  
   }

  Viewreports() {
  
    localStorage["ReportName"] = "NationalOrganizationReport";
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));

    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }
}
